<template>
  <div class="h-full overflow-hidden flex flex-col" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.5)">
    <div class="icon-search__input mt-10px mb-10px">
      <el-input
        placeholder="设备编码或名称"
        v-model="treeKeyWords"
        size="small"
        clearable
        @keypress.enter.native="getDeviceList"
      >
        <i slot="append" class="el-icon-search cursor-pointer" @click="getDeviceList"></i>
      </el-input>
    </div>
    <div class="flex-1 overflow-auto border-[#45f2eb33] border-1px text-white text-14px p-10px">
      <div
        class="cursor-pointer truncate device-item"
        :class="{'cur-device': curDevice.threeDimensionalObjectCode === item.threeDimensionalObjectCode}"
        v-for="(item, index) in deviceList"
        :key="index"
        @click="rowClick(item)">{{item.threeDimensionalObjectCode || '--'}}</div>
    </div>
    <categoryTitle class="mt-10px mb-10px" title="资料文件" v-if="fileData.length"/>
    <div class="file-box">
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item :name="item.name" v-for="(item, index) in fileData" :key="index">
          <template slot="title">
            <span>{{item.name}}（{{item.num}}）</span>
          </template>
          <el-table max-height="250px" :data="item.data" highlight-current-row>
            <el-table-column label="" width="20">
              <template>
                <div class="selected-row"></div>
              </template>
            </el-table-column>
            <el-table-column label="名称" prop="name" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="{row}">
                <span class="cursor-pointer" @click="searchFile(row)">查看</span>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </div>
    <fileView  v-if="fileShow" @close="fileShow=false" :detailInfo="detailInfo"></fileView>
  </div>
</template>

<script>
import { VirtualTagTreeFileApi, VirtualTagTreeTagRelationApi } from '@wiz-api/tag-roam-sis-management'
import categoryTitle from '@/components/cockpit/CategoryTitle'
import fileView from './fileView'

const virtualTagTreeFileApi = new VirtualTagTreeFileApi()
const virtualTagTreeTagRelationApi = new VirtualTagTreeTagRelationApi()
// console.log(VirtualTagTreeFileApi.Methods)
export default {
  name: 'DeviceList',
  components: {
    categoryTitle,
    fileView
  },
  props: {
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      treeKeyWords: '',
      currentNodeInfo: {},
      deviceList: [],
      curDevice: {},
      fileData: [],
      loading: false,
      activeName: '',
      fileShow: false,
      detailInfo: {}
    }
  },
  watch: {
    transferProps: {
      handler(data) {
        // console.log(data, 'transferProps deviceList')
        if (data?.id) {
          this.currentNodeInfo = data
          this.curDevice = {}
          this.getDeviceList()
          this.getFileData()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    rowClick(row) {
      this.curDevice = row
      // this.player.Native.Camera.moveToCode(row.tagCode, 1)
      this.getFileData()
    },
    // 查询资料文件
    async getFileData() {
      this.loading = true
      const [err, res] = await virtualTagTreeFileApi.getFileInformation({
        body: {
          virtualTagTreeId: this.currentNodeInfo.id,
          threeDimensionalObjectCode: this.curDevice.threeDimensionalObjectCode
        }
      })
      if (!err) {
        const fileData = []
        const { drawingList = [], exceptionHandleList = [], accidentCaseList = [], operationInstructionList = [] } = res
        if (drawingList.length) {
          fileData.push({
            name: '图纸',
            num: res.drawingAmount,
            data: drawingList
          })
        }
        if (exceptionHandleList.length) {
          fileData.push({
            name: '异常处理',
            num: res.exceptionHandleAmount,
            data: exceptionHandleList
          })
        }
        if (accidentCaseList.length) {
          fileData.push({
            name: '事故案例',
            num: res.accidentCaseAmount,
            data: accidentCaseList
          })
        }
        if (operationInstructionList.length) {
          fileData.push({
            name: '操作指导',
            num: res.operationInstructionAmount,
            data: operationInstructionList
          })
        }
        this.fileData = fileData
        if (fileData.length) {
          this.activeName = fileData[0].name
        }
      }
      this.loading = false
    },
    // 获取设备列表
    async getDeviceList() {
      const [err, res] = await virtualTagTreeTagRelationApi.getList({
        virtualTagTreeId: this.currentNodeInfo.id,
        codeOrName: this.treeKeyWords,
        skipCount: 0,
        maxResultCount: 999
      })
      if (!err) {
        this.deviceList = res.items.filter((item) => { return item.isDisplay })
      }
    },
    searchFile(row) {
      this.detailInfo = row
      this.fileShow = true
    }
  },
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-collapse {
    border-top: transparent;
    border-bottom: transparent;

    .el-collapse-item {
      margin-bottom: 5px;
    }

    .el-collapse-item__header {
      padding-left: 10px;
      height: 36px;
      color: #fff;
      background: transparent;
      border: 1px solid #0e7a84;
      line-height: 36px;
    }

    .el-collapse-item__arrow.el-icon-arrow-right {
      color: #fff;
    }

    .el-collapse-item__wrap {
      color: #fff;
      background-color: transparent;
      border-bottom: transparent;
    }

    .el-collapse-item__content {
      padding: 0;
      color: #fff;
    }
  }
  .device-item {
    margin: 1px 0;
    padding: 4px 10px;
    border-radius: 2px;
    &:hover {
      background: #005d657f;
    }
  }
  .cur-device {
    background: #005d657f;
  }
</style>
